export default __webpack_public_path__ + "static/media/C2_30_x_45_Noir.6925944e.jpg";